import { Component, Input, ElementRef, OnDestroy, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { Image } from '../../interfaces/image';
import 'slick-carousel';
import * as $ from 'jquery';

@Component({
  selector: 'app-crew-slideshow',
  templateUrl: './crew-slideshow.component.html',
  styleUrls: ['./crew-slideshow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CrewSlideshowComponent implements AfterViewInit, OnDestroy {
  @Input() crewMembers: {
    name: string;
    job_title?: string;
    image?: Image;
  }[];
  $slideshow;

  constructor(private el: ElementRef) {
  }

  initializeSlideshow() {
    this.$slideshow.slick({
      centerMode: true,
      centerPadding: '30px',
      slidesToShow: 5,
      slidesToScroll: 1,
      speed: 200,
      focusOnSelect: true,
      cssEase: 'ease-in-out',
      swipeToSlide: true,
      draggable: true,
      swipe: true,
      dots: false,
      prevArrow: $('.arrow--prev', this.el.nativeElement),
      nextArrow: $('.arrow--next', this.el.nativeElement),
      responsive: [
        {
          breakpoint: 1048,
          settings: {
            slidesToShow: Math.floor(this.crewMembers.length / 3)
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  ngAfterViewInit() {
    if (this.crewMembers && this.crewMembers.length) {
      this.$slideshow = $('.carousel', this.el.nativeElement);
      this.initializeSlideshow();
    }
  }

  ngOnDestroy() {
    if (this.$slideshow) {
      this.$slideshow.slick('unslick');
    }
  }
}
